/**
 * Nhóm dự án
 */
export default {
  GroupCountry: 1,
  GroupA: 2,
  GroupB: 3,
  GroupC: 4,
};
